import React, { useEffect } from 'react';
import AppLayout from '../common/layouts/appLayout';
import PublicFooterLayout from './components/publicLayout';
import PrivacyPolicyContent from './components/privacyPolicyContent';
import { useSelector, useDispatch } from 'react-redux';
import { clientsFilteredSearch } from '../services/programClientsSlice';
import { getsiteConfigurationInfo } from '../services/siteConfigurationSlice';

const PrivacyPolicy = ({ isAuthenticatedUser }) => {
  const dispatch = useDispatch();
  const selectedClients = useSelector(
    (state) => state.programsClientsSlice.selectedClient
  );
  const clientPrograms = useSelector(
    (state) => state.programsClientsSlice.programClients
  );
  if (!selectedClients.payload && isAuthenticatedUser) {
    dispatch(clientsFilteredSearch(clientPrograms));
    const programId = clientPrograms[0].programid;
    dispatch(getsiteConfigurationInfo({ programId }));
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {isAuthenticatedUser ? (
        <AppLayout>
          <PrivacyPolicyContent isAuthenticatedUser={isAuthenticatedUser} />
        </AppLayout>
      ) : (
        <PublicFooterLayout title="Privacy Policy">
          <PrivacyPolicyContent isAuthenticatedUser={isAuthenticatedUser} />
        </PublicFooterLayout>
      )}
    </>
  );
};

export default PrivacyPolicy;
